import * as React from 'react';
import { Icon } from '@seeqdev/qomponents';
import { setAIAssistantDisplayed } from '@/aiAssistant/aiAssistant.actions';
import { useFluxPath } from '@/core/hooks/useFluxPath.hook';
import { sqAiAssistantStore } from '@/core/core.stores';

export const HeaderAIAssistant: React.FunctionComponent = () => {
  const aiAssistantDisplayed = useFluxPath(sqAiAssistantStore, () => sqAiAssistantStore.displayed);

  return (
    <>
      <Icon
        icon={`fa-sparkles`}
        iconPrefix="fa-solid"
        testId="headerAIIcon"
        type="white"
        extraClassNames="pl5 pt3 pr5 sq-navbar-default fa-xl"
        tooltip="AI Assistant"
        tooltipPlacement="bottom"
        onClick={() => {
          setAIAssistantDisplayed(!aiAssistantDisplayed);
        }}
      />
    </>
  );
};
